import {
  normalizePassiveListenerOptions,
  supportsPassiveEventListeners,
} from '@angular/cdk/platform';
import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { HasSubscription } from 'src/ca-shared/has-subscription/has-subscription';

@Component({
  selector: 'ca-base-dropdown-selector-scroll',
  templateUrl: './base-dropdown-selector-scroll.component.html',
  styleUrls: ['./base-dropdown-selector-scroll.component.scss'],
})
export abstract class BaseDropdownSelectorScrollComponent
  extends HasSubscription
  implements OnDestroy, OnInit
{
  @ViewChild('ngSelect', { read: NgSelectComponent, static: false })
  ngSelect: NgSelectComponent;

  private _onScrollFn: () => void;

  constructor(protected ngZone: NgZone) {
    super();
  }

  ngOnInit(): void {
    let eventOptions: AddEventListenerOptions | boolean;

    if (supportsPassiveEventListeners()) {
      //use the implementation on mozilla
      eventOptions = normalizePassiveListenerOptions({
        capture: true,
        passive: true,
      });
    } else {
      eventOptions = true;
    }

    this._onScrollFn = this.onScroll.bind(this);

    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', this._onScrollFn, eventOptions);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this._onScrollFn, true);
  }

  private onScroll(): void {
    if (this.ngSelect && this.ngSelect.isOpen) {
      this.ngZone.run(() => {
        this.ngSelect.dropdownPanel.adjustPosition();
      });
    }
  }
}
